export default {
  init() {
    var nav_button_timeline_click = false;


      jQuery('.timeline-holder').each(function(){
        var holder = jQuery(this);
        var slickContent = holder.find('.timeline-content');
        var slickDate = holder.find('.timeline-date-content');
        var btnHolder = holder.find('.timeline-controls');
        var dotsHolder = holder.find('.timeline-dots');
        var nbDots = slickDate.children().length;

        slickDate.slick({
          mobileFirst: true,
          dots: false,
          infinite: false,
          rows: 1,
          speed: 300,
          slidesToShow: nbDots,
          slidesToScroll: nbDots,
          adaptiveHeight: true,
          arrows: false,
          asNavFor: '.timeline-content',
          appendArrows: btnHolder,
          appendDots: dotsHolder,
          zIndex: 1000,
        });
        slickContent.slick({
          mobileFirst: true,
          dots: true,
          infinite: false,
          rows: 1,
          fade: true,
          speed: 300,
          slidesToShow:1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          arrows: true,
          asNavFor: '.timeline-date-content',
          appendArrows: btnHolder,
          appendDots: dotsHolder,
          zIndex: 1000,
        });
      });

      function setButtonAriaDisabled(){
        setTimeout(function(){
          var index = $('ul.timeline-date-content li.slick-slide.slick-current').attr('data-slick-index');
          var length = $('ul.timeline-date-content li.slick-slide.slick-current').parent().children().length;

          if(index >= Math.floor(length -1)){
            $('#timeline-next-bottom').attr('aria-disabled', 'true');
            $('#timeline-prev-bottom').attr('aria-disabled', 'false');
            $('#timeline-prev-bottom').removeClass('timeline-disabled');
            if(!$('#timeline-next-bottom').hasClass('timeline-disabled')){
              $('#timeline-next-bottom').addClass('timeline-disabled');
            }
            $('#timeline-next-top').attr('aria-disabled', 'true');
            $('#timeline-prev-top').attr('aria-disabled', 'false');
            $('#timeline-prev-top').removeClass('timeline-disabled');
            if(!$('#timeline-next-top').hasClass('timeline-disabled')){
              $('#timeline-next-top').addClass('timeline-disabled');
            }

          }else if(index <= 0){
            $('#timeline-prev-bottom').attr('aria-disabled', 'true');
            $('#timeline-next-bottom').attr('aria-disabled', 'false');
            $('#timeline-next-bottom').removeClass('timeline-disabled');
            if(!$('#timeline-prev-bottom').hasClass('timeline-disabled')){
              $('#timeline-prev-bottom').addClass('timeline-disabled');
            }
            $('#timeline-prev-top').attr('aria-disabled', 'true');
            $('#timeline-next-top').attr('aria-disabled', 'false');
            $('#timeline-next-top').removeClass('timeline-disabled');
            if(!$('#timeline-prev-top').hasClass('timeline-disabled')){
              $('#timeline-prev-top').addClass('timeline-disabled');
            }
          }else{
            $('#timeline-prev-bottom').attr('aria-disabled', 'false');
            $('#timeline-next-bottom').attr('aria-disabled', 'false');
            $('#timeline-prev-bottom').removeClass('timeline-disabled');
            $('#timeline-next-bottom').removeClass('timeline-disabled');
            $('#timeline-prev-top').attr('aria-disabled', 'false');
            $('#timeline-next-top').attr('aria-disabled', 'false');
            $('#timeline-prev-top').removeClass('timeline-disabled');
            $('#timeline-next-top').removeClass('timeline-disabled');
          }

        }, 300);
      }
      jQuery('#timeline-prev-bottom').on('click', function(e){
        if(nav_button_timeline_click == false){
          nav_button_timeline_click = true;
          setTimeout(function(){
            nav_button_timeline_click = false;
          }, 600);
          $('.timeline-controls button.slick-prev.slick-arrow').trigger('click');
          if(!$(e.currentTarget).hasClass('timeline-disabled')){
            $('.timeline-holder .slick-dots').css('left', (parseInt($('.timeline-holder .slick-dots').css('left')) + 100) + 'px');
            $('.timeline-holder ul.timeline-date-content').css('left', (parseInt($('.timeline-holder ul.timeline-date-content').css('left')) + 100) + 'px');
          }
          setButtonAriaDisabled();
        }
      });
      jQuery('#timeline-next-bottom').on('click', function(e){
        if(nav_button_timeline_click == false){
          nav_button_timeline_click = true;
          setTimeout(function(){
            nav_button_timeline_click = false;
          }, 600);
          $('.timeline-controls button.slick-next.slick-arrow').trigger('click');
          if($(e.currentTarget).hasClass('timeline-disabled') == false){
            $('.timeline-holder .slick-dots').css('left', (parseInt($('.timeline-holder .slick-dots').css('left')) + -100) + 'px');
            $('.timeline-holder ul.timeline-date-content').css('left', (parseInt($('.timeline-holder ul.timeline-date-content').css('left')) + -100) + 'px');
            setButtonAriaDisabled();
          }
        }
      });
      jQuery('#timeline-prev-top').on('click', function(e){
        if(nav_button_timeline_click == false){
          nav_button_timeline_click = true;
          setTimeout(function(){
            nav_button_timeline_click = false;
          }, 600);
          $('.timeline-controls button.slick-prev.slick-arrow').trigger('click');
          if(!$(e.currentTarget).hasClass('timeline-disabled')){
            $('.timeline-holder .slick-dots').css('left', (parseInt($('.timeline-holder .slick-dots').css('left')) + 100) + 'px');
            $('.timeline-holder ul.timeline-date-content').css('left', (parseInt($('.timeline-holder ul.timeline-date-content').css('left')) + 100) + 'px');
          }
          setButtonAriaDisabled();
        }
      });
      jQuery('#timeline-next-top').on('click', function(e){
        if(nav_button_timeline_click == false){
          nav_button_timeline_click = true;
          setTimeout(function(){
            nav_button_timeline_click = false;
          }, 600);
          $('.timeline-controls button.slick-next.slick-arrow').trigger('click');
          if($(e.currentTarget).hasClass('timeline-disabled') == false){
            $('.timeline-holder .slick-dots').css('left', (parseInt($('.timeline-holder .slick-dots').css('left')) + -100) + 'px');
            $('.timeline-holder ul.timeline-date-content').css('left', (parseInt($('.timeline-holder ul.timeline-date-content').css('left')) + -100) + 'px');
            setButtonAriaDisabled();
          }
        }
      });
      jQuery('.timeline-holder .slick-dots li').each(function(){
        jQuery(this).on('click', function(e){
          if($(e.currentTarget).hasClass('slick-active')){
            var index = $(e.currentTarget).parent().children().index(e.currentTarget);
            var left = -100 * index;
            $(e.currentTarget.parentNode).css('left', left + 'px');
            $('.timeline-holder ul.timeline-date-content').css('left', left + 'px');
          }
          setButtonAriaDisabled();
        });
      });
      jQuery('.timeline-holder .timeline-controls button').each(function(){
        jQuery(this).on('mousedown', function(e){
          if(nav_button_timeline_click == false){
            nav_button_timeline_click = true;
            var def = 0;
            var left = 0;
            if($(e.currentTarget).hasClass('slick-next') || $(e.currentTarget).hasClass('timeline-next')){
              def = $('.timeline-holder ul.timeline-date-content').children().lenght * -100;
              left = -100;
            }else if($(e.currentTarget).hasClass('slick-prev') || $(e.currentTarget).hasClass('timeline-prev')){
              def = 0;
              left = 100;
            }

            if($(e.currentTarget).attr('aria-disabled') == 'false'){
              $('.timeline-holder .slick-dots').css('left', (parseInt($('.timeline-holder .slick-dots').css('left')) + left) + 'px');
              $('.timeline-holder ul.timeline-date-content').css('left', (parseInt($('.timeline-holder ul.timeline-date-content').css('left')) + left) + 'px');
            }else{
              $('.timeline-holder .slick-dots').css('left', def + 'px');
              $('.timeline-holder ul.timeline-date-content').css('left', def + 'px');
            }

            setButtonAriaDisabled();
            nav_button_timeline_click = false;
          }
        });
      });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/timeline.js